/* Generated from Java with JSweet 2.3.5 - http://www.jsweet.org */
import { OasLicense } from '../../models/OasLicense';

/**
 * Constructor.
 * @class
 * @extends OasLicense
 * @author eric.wittmann@gmail.com
 */
export class Oas20License extends OasLicense {
    public constructor() {
        super();
    }
}
Oas20License["__class"] = "io.apicurio.datamodels.openapi.v2.models.Oas20License";
Oas20License["__interfaces"] = ["io.apicurio.datamodels.core.models.IVisitable"];




